import React, { useState } from "react";
import {
  Card,
  Badge,
  Collapse,
  Button,
  CustomInput,
  FormGroup,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import {
  AddCommaNumber,
  getImageUrl,
  getPlaceholderIcon,
} from "../../../helpers/Utils";
import { Colxx } from "../../../components/common/CustomBootstrap";
import moment from "moment";

const formatAttributes = (variantObject, intl) => {
  const attributeKeys = ["color", "size", "material"];
  const labels = attributeKeys
    .map((key) => variantObject?.attributes?.[key]?.label)
    .filter(Boolean);
  return (
    labels.join(" - ") || intl.formatMessage({ id: "product.variant.default" })
  );
};

// const formatDateRange = (v) => {
//     const { date_start, date_end } = v;
//     const d_start = !date_start ? null : moment(date_start).format('DD/MM/YYYY')
//     const d_end = !date_end ? null : moment(date_end).format('DD/MM/YYYY')
//     if (d_start && d_end) {
//         // Giả sử d_start và d_end là chuỗi ngày tháng, cần định dạng lại cho đẹp hơn
//         return `${d_start} - ${d_end}`;
//     }
//     if (d_start && !d_end) {
//         return `Bắt đầu từ ${d_start}`;
//     }
//     return 'Luôn áp dụng';
// };

const formatDateRange = (v = {}, intl) => {
  const { date_start, date_end, promo_price } = v;

  if (!promo_price || parseFloat(promo_price) === 0) {
    return "-";
  }

  if (!date_start) {
    return "-";
  }

  const today = moment().startOf("day");
  const momentStart = moment(date_start);
  const formattedStart = momentStart.format("DD/MM/YYYY");

  if (date_end) {
    const formattedEnd = moment(date_end).format("DD/MM/YYYY");
    return `${formattedStart} - ${formattedEnd}`;
  }

  if (momentStart.isAfter(today)) {
    return intl.formatMessage(
      { id: "product.variant.coming_soon" },
      { date: formattedStart },
    );
  }

  return intl.formatMessage(
    { id: "product.variant.starts_from" },
    { date: formattedStart },
  );
};

const calculateVariantsPriceRange = (variants) => {
  if (!variants || variants.length === 0) {
    return null;
  }

  let minPrice = Infinity;
  let maxPrice = -Infinity;
  let minPromoPrice = Infinity;
  let maxPromoPrice = -Infinity;

  let hasActivePromotion = false;

  // Lấy ngày hiện tại và set giờ về 0 để so sánh ngày chính xác
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  variants.forEach((variant) => {
    const price = parseFloat(variant.price);
    const promoPrice = parseFloat(variant.promo_price);

    // Cập nhật dải giá gốc
    if (!isNaN(price)) {
      if (price < minPrice) minPrice = price;
      if (price > maxPrice) maxPrice = price;
    }

    let isPromoActive = false;

    if (!isNaN(promoPrice) && promoPrice > 0) {
      const startDate = variant.date_start
        ? new Date(variant.date_start)
        : null;
      const endDate = variant.date_end ? new Date(variant.date_end) : null;

      if (startDate) startDate.setHours(0, 0, 0, 0);
      if (endDate) endDate.setHours(0, 0, 0, 0);

      // Case 1: Có cả ngày bắt đầu và kết thúc
      if (startDate && endDate) {
        if (today >= startDate && today <= endDate) {
          isPromoActive = true;
        }
      }
      // Case 2: Chỉ có ngày bắt đầu, không có ngày kết thúc
      else if (startDate && !endDate) {
        if (today.getTime() >= startDate.getTime()) {
          isPromoActive = true;
        }
      }
      // Case 3: Không có ngày bắt đầu/kết thúc nhưng có giá KM
      else if (!startDate && !endDate) {
        isPromoActive = true;
      }
    }

    if (isPromoActive) {
      hasActivePromotion = true;
      if (promoPrice < minPromoPrice) minPromoPrice = promoPrice;
      if (promoPrice > maxPromoPrice) maxPromoPrice = promoPrice;
    }
  });

  // Nếu không tìm thấy khuyến mãi nào đang hoạt động, trả về null cho dải giá KM
  if (!hasActivePromotion) {
    minPromoPrice = null;
    maxPromoPrice = null;
  }

  return {
    minPrice: minPrice === Infinity ? null : minPrice,
    maxPrice: maxPrice === -Infinity ? null : maxPrice,
    minPromoPrice,
    maxPromoPrice,
  };
};

const calcVariantPriceRange = (variant) => {
  // Lấy ngày hiện tại và set giờ về 0 để so sánh ngày chính xác
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const promoPrice = parseFloat(variant.promo_price);

  let isPromoActive = false;

  if (!isNaN(promoPrice) && promoPrice > 0) {
    const startDate = variant.date_start ? new Date(variant.date_start) : null;
    const endDate = variant.date_end ? new Date(variant.date_end) : null;

    if (startDate) startDate.setHours(0, 0, 0, 0);
    if (endDate) endDate.setHours(0, 0, 0, 0);

    // Case 1: Có cả ngày bắt đầu và kết thúc
    if (startDate && endDate) {
      if (today >= startDate && today <= endDate) {
        isPromoActive = true;
      }
    }
    // Case 2: Chỉ có ngày bắt đầu, không có ngày kết thúc
    else if (startDate && !endDate) {
      if (today >= startDate) {
        isPromoActive = true;
      }
    }
    // Case 3: Không có ngày bắt đầu/kết thúc nhưng có giá KM
    else if (!startDate && !endDate) {
      isPromoActive = true;
    }
  }

  if (isPromoActive) {
    return promoPrice;
  }
};

const LabelItemLeft = (props) => {
  const {
    item,
    idx,
    selectedItems,
    isDisabledUpdate,
    onUpdate,
    onChangeCheckbox,
    make_products,
    business_type,
    intl,
  } = props;

  // State cho collapse biến thể
  const [isVariantsOpen, setIsVariantsOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  const toggleVariants = (e) => {
    e.stopPropagation();
    setIsVariantsOpen((prevState) => !prevState);
  };

  let priceDisplayContent = null;
  const hasVariants = item.variant && item.variant.length > 0;

  if (hasVariants) {
    const range = calculateVariantsPriceRange(item.variant);
    if (range) {
      // Hiển thị dải giá cho sản phẩm có biến thể
      const priceRangeText =
        range.minPrice === range.maxPrice
          ? AddCommaNumber(range.minPrice)
          : `${AddCommaNumber(range.minPrice)} - ${AddCommaNumber(
              range.maxPrice,
            )}`;

      const promoRangeText =
        range.minPromoPrice && range.maxPromoPrice
          ? range.minPromoPrice === range.maxPromoPrice
            ? AddCommaNumber(range.minPromoPrice)
            : `${AddCommaNumber(range.minPromoPrice)} - ${AddCommaNumber(
                range.maxPromoPrice,
              )}`
          : null;

      priceDisplayContent = (
        <>
          {promoRangeText ? (
            <>
              <Badge color="light" pill className="mr-1 mb-1">
                <del>{priceRangeText}</del>
              </Badge>
              <Badge color="primary" pill>
                {promoRangeText}
              </Badge>
            </>
          ) : (
            <Badge color="primary" pill>
              {priceRangeText}
            </Badge>
          )}
        </>
      );
    }
  } else {
    // Logic hiển thị giá gốc cho sản phẩm không có biến thể
    priceDisplayContent = (
      <>
        {item.active_sale && parseFloat(item.price_sale) > 0 ? (
          <>
            <Badge color="light" pill className="mr-1 mb-1">
              <del>{AddCommaNumber(parseFloat(item.price))}</del>
            </Badge>
            <Badge color="primary" pill>
              {AddCommaNumber(parseFloat(item.price_sale))}
            </Badge>
          </>
        ) : (
          <Badge color="primary" pill>
            {AddCommaNumber(parseFloat(item.price))}
          </Badge>
        )}
      </>
    );
  }

  const imageUrl = getImageUrl(item.image);

  // 3. Tối ưu hóa việc tính toán giá bằng useMemo
  // const priceDisplayContent = useMemo(() => {
  // const hasVariants = item.variant && item.variant.length > 0;

  // if (hasVariants) {
  //     // Tách logic tính toán dải giá để dễ đọc hơn
  //     const prices = item.variant.map(v => parseFloat(v.price));
  //     const promoPrices = item.variant.map(v => v.promo_price !== '0' ? parseFloat(v.promo_price) : null).filter(p => p !== null);

  //     const minPrice = Math.min(...prices);
  //     const maxPrice = Math.max(...prices);

  //     const priceRangeText = minPrice === maxPrice ? AddCommaNumber(minPrice) : `${AddCommaNumber(minPrice)} - ${AddCommaNumber(maxPrice)}`;

  //     if (promoPrices.length > 0) {
  //         const minPromoPrice = Math.min(...promoPrices);
  //         const maxPromoPrice = Math.max(...promoPrices);
  //         const promoRangeText = minPromoPrice === maxPromoPrice ? AddCommaNumber(minPromoPrice) : `${AddCommaNumber(minPromoPrice)} - ${AddCommaNumber(maxPromoPrice)}`;

  //         return (
  //             <>
  //                 <Badge color='light' pill className='mr-1 mb-1'><del>{priceRangeText}</del></Badge>
  //                 <Badge color='primary' pill>{promoRangeText}</Badge>
  //             </>
  //         );
  //     }

  //     return <Badge color='primary' pill>{priceRangeText}</Badge>;
  // } else {
  //     // Logic cho sản phẩm không có biến thể
  //     return (
  //         <>
  //             {item.active_sale ? (
  //                 <>
  //                     <Badge color='light' pill className='mr-1 mb-1'><del>{AddCommaNumber(parseFloat(item.price))}</del></Badge>
  //                     <Badge color='primary' pill>{AddCommaNumber(parseFloat(item.price_sale))}</Badge>
  //                 </>
  //             ) : (
  //                 <Badge color='primary' pill>{AddCommaNumber(parseFloat(item.price))}</Badge>
  //             )}
  //         </>
  //     );
  // }
  // }, [item]); // Chỉ tính toán lại khi 'item' thay đổi

  return (
    <>
      <Card
        className={classnames("mb-3 custom-shadow", {
          active: selectedItems.includes(item.id),
        })}
        style={{ position: "relative" }}
      >
        <div className="d-flex flex-column">
          {/* Phần thông tin chính của sản phẩm */}
          <div className="d-flex flex-grow-1 min-width-zero">
            <div
              className="d-flex flex-grow-1 min-width-zero overflow-hidden"
              onClick={(e) => {
                // Click trực tiếp vào card để mở edit modal (thay vì chỉ select)
                if (!isDisabledUpdate) {
                  onUpdate(item);
                }
              }}
              style={{ cursor: isDisabledUpdate ? "default" : "pointer" }}
            >
              <div
                className={classnames("d-block position-relative", {
                  disable: item.softHide,
                })}
              >
                {imageError || !imageUrl ? (
                  // Hiển thị icon placeholder khi ảnh lỗi
                  <div className="list-thumbnail responsive border-0 d-flex align-items-center justify-content-center m-1 product-placeholder">
                    <i
                      className={getPlaceholderIcon(
                        business_type,
                        item.fnb_type,
                      )}
                      style={{
                        fontSize: "50px",
                        color: "#888",
                      }}
                    />
                  </div>
                ) : (
                  <img
                    alt={item.name}
                    src={imageUrl}
                    onError={() => setImageError(true)}
                    className="list-thumbnail responsive border-0 m-1 cursor-pointer product-placeholder"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                )}
                {item.bestter && (
                  <Badge
                    className="position-absolute badge-top-right"
                    color={"success"}
                    pill
                  >
                    <IntlMessages id="page.heading.best_seller" />
                  </Badge>
                )}
              </div>
              <div
                className={classnames(
                  "card-body card-body-custom w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center",
                  { disable: item.softHide },
                )}
                style={{ overflow: "hidden" }}
              >
                <div
                  className="list-item-heading mb-1 truncate d-block cursor-pointer min-width-zero pr-3"
                  style={{ flex: "1 1 0", minWidth: 0, overflow: "hidden" }}
                >
                  {/* <div className="d-flex justify-content-between">
                    <div> */}
                      <span>{item.name}</span>
                      <p className="text-muted text-small mb-0">
                        SKU: {item.sku}
                        {item.barcode ? ` | ${intl.formatMessage({ id: "product.barcode" })}: ${item.barcode}` : ""}
                      </p>
                    {/* </div>
                    <div>
                      {item.category && item.category.name && (
                        <Badge color="outline-secondary" pill className="mb-1" style={{ fontSize: "10px" }}>
                          Danh mục: {item.category.name}
                        </Badge>
                      )}
                      {(() => {
                        // Tồn kho: chỉ hiện khi có đúng 1 MakeProduct với count=1 (định lượng 1:1)
                        const recipes = make_products.filter((m) => m.product_id === item.id);
                        if (
                          recipes.length === 1 &&
                          Number(recipes[0].count) === 1 &&
                          recipes[0].stock
                        ) {
                          const stockCount = recipes[0].stock.count;
                          return (
                            <Badge
                              color={stockCount > 0 ? "outline-info" : "outline-danger"}
                              pill
                              className="ml-1 mb-1"
                              style={{ fontSize: "10px" }}
                            >
                              {intl.formatMessage({ id: "product.stock-count" })}: {AddCommaNumber(stockCount)}
                            </Badge>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  </div> */}
                  <div
                    className="mt-3"
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      display: "flex",
                      flexWrap: "nowrap",
                      gap: "4px",
                      maxWidth: "100%",
                    }}
                  >
                    {make_products.length
                      ? make_products
                          .filter((make) => make.product_id === item.id)
                          .map((stock, idx) => (
                            <Badge
                              className="mr-1 mb-1"
                              color="outline-dark"
                              pill
                              key={idx}
                              style={{ fontSize: "11px", flexShrink: 0 }}
                            >
                              {`${stock.stock.name} - ${stock.count} ${
                                stock.stock.unit
                              } - ${AddCommaNumber(
                                stock.stock.price_new * Number(stock.count),
                              )} đ`}
                            </Badge>
                          ))
                      : null}
                  </div>
                </div>
                <div className="d-flex flex-column align-items-center w-20 w-sm-100">
                  <p>{priceDisplayContent}</p>
                  <div>
                    {item.category && item.category.name && (
                      <div>
                        <Badge color="outline-secondary" pill className="mb-1" style={{ fontSize: "10px" }}>
                          Danh mục: {item.category.name}
                        </Badge>
                      </div>
                    )}
                    {(() => {
                      // Tồn kho: chỉ hiện khi có đúng 1 MakeProduct với count=1 (định lượng 1:1)
                      const recipes = make_products.filter((m) => m.product_id === item.id);
                      if (
                        recipes.length === 1 &&
                        Number(recipes[0].count) === 1 &&
                        recipes[0].stock
                      ) {
                        const stockCount = recipes[0].stock.count;
                        return (
                          <Badge
                            color={stockCount > 0 ? "outline-info" : "outline-danger"}
                            pill
                            style={{ fontSize: "10px" }}
                          >
                            {intl.formatMessage({ id: "product.stock-count" })}: {AddCommaNumber(stockCount)}
                          </Badge>
                        );
                      }
                      return null;
                    })()}
                  </div>
                </div>
              </div>
            </div>
            {/* Checkbox để chọn sản phẩm */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onChangeCheckbox(item.id, e);
              }}
            >
              <FormGroup className="mb-0">
                <CustomInput
                  type="checkbox"
                  id={`check-product-${item.id}`}
                  label=""
                  checked={selectedItems.includes(item.id)}
                  onChange={() => {}}
                />
              </FormGroup>
            </div>
          </div>

          {/* Biến thể toggle - positioned bottom-right */}
          {item.variant && item.variant.length ? (
            <div
              className="variant-toggle-badge d-flex align-items-center text-small"
              onClick={(e) => {
                e.stopPropagation();
                toggleVariants(e);
              }}
              style={{
                cursor: "pointer",
                position: "absolute",
                bottom: "8px",
                right: "12px",
                backgroundColor: "#f0f0f0",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                color: "#666",
                zIndex: 10,
              }}
            >
              <span className="font-weight-bold">
                <IntlMessages id="product.variants" /> ({item.variant.length})
              </span>
              <i
                className={`simple-icon-arrow-${
                  isVariantsOpen ? "up" : "down"
                } ml-1`}
                style={{ fontSize: "10px" }}
              />
            </div>
          ) : null}

          {/* 4. Phần hiển thị biến thể với Collapse */}
          {item?.variant && item.variant.length > 0 && (
            <Collapse
              isOpen={isVariantsOpen}
              className="mt-3"
              style={{ marginBottom: "35px" }}
            >
              <div className="d-flex font-weight-bold border-bottom pb-2">
                <div className="d-flex w-100 px-3">
                  <Colxx xxs="3">
                    <IntlMessages id="product.variant.name" />
                  </Colxx>
                  <Colxx xxs="2">
                    <IntlMessages id="product.variant.sku" />
                  </Colxx>
                  <Colxx xxs="2">
                    <IntlMessages id="product.variant.price" />
                  </Colxx>
                  <Colxx xxs="2">
                    <IntlMessages id="product.variant.stock" />
                  </Colxx>
                  <Colxx xxs="3">
                    <IntlMessages id="product.variant.promo_time" />
                  </Colxx>
                </div>
              </div>
              {[...item.variant]
                .sort((a, b) => a.id - b.id)
                .map((v, variantIdx) => {
                  let priceVariant = calcVariantPriceRange(v);
                  return (
                    <div className="d-flex my-3" key={variantIdx}>
                      <div className="d-flex align-items-center w-100 px-3">
                        <Colxx xxs="3">{formatAttributes(v, intl)}</Colxx>
                        <Colxx xxs="2">{v.sku}</Colxx>
                        <Colxx xxs="2">
                          {priceVariant ? (
                            <>
                              <Badge color="light" pill className="mr-1 mb-1">
                                <del>{AddCommaNumber(v.price)}</del>
                              </Badge>
                              <Badge color="primary" pill>
                                {AddCommaNumber(priceVariant)}
                              </Badge>
                            </>
                          ) : (
                            <Badge color="primary" pill>
                              {AddCommaNumber(v.price)}
                            </Badge>
                          )}
                        </Colxx>
                        <Colxx xxs="2">
                          {business_type === "cafe" ||
                          business_type === "restaurant"
                            ? "-"
                            : v.quantity || 0}
                        </Colxx>{" "}
                        {/* Giả sử tồn kho là v.quantity */}
                        <Colxx xxs="3">{formatDateRange(v, intl)}</Colxx>
                      </div>
                    </div>
                  );
                })}
            </Collapse>
          )}
        </div>
      </Card>
    </>
  );
};

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
const MemoizedLabelItemLeft = React.memo(LabelItemLeft);

export default injectIntl(
  connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
  })(MemoizedLabelItemLeft),
);
